import { enumsTranslationKeys } from 'src/commons/i18nEnums'

export { default as MultiSelectChips } from './MultiSelectChips'
export { default as SelectBox } from './SelectBox'

export const buildItemsFromEnum = (fromEnum: keyof typeof enumsTranslationKeys, t: (k: string) => string) => {
  return Object.entries(enumsTranslationKeys[fromEnum]).map(([key, val]) => {
    const label = t(val)
    return {
      label: label.charAt(0).toUpperCase() + label.slice(1),
      id: key,
    }
  })
}
